export const encodeParam = (param) => {
  return btoa(encodeURIComponent(param)); // 编码
}

export const decodeParam = (encoded) => {
  return decodeURIComponent(atob(encoded)); // 解码
}
